type param = {
  chainCode?: string
  prefecture?: string
  stationCode?: string
  areaSlug?: string
  keyword?: string
  near?: boolean
  selectedDay?: string
  conditions?: Record<string, string>
}

export const getSearchPagePath = ({
  areaSlug,
  chainCode,
  prefecture,
  stationCode,
  keyword,
  selectedDay = '0',
  near,
  conditions = {},
}: param) => {
  let path = '/search'

  if (near) path += '/near'

  if (keyword && !prefecture && !areaSlug && !stationCode && !chainCode) {
    path += `/list`
    
    // URLSearchParamsを使用してクエリパラメータを構築
    const searchParams = new URLSearchParams()
    searchParams.set('keyword', keyword)
    
    // conditionsオブジェクトから直接クエリパラメータを設定
    Object.entries(conditions).forEach(([key, value]) => {
      searchParams.set(key, value)
    })
    
    return path + `?${searchParams.toString()}`
  }

  if (prefecture === 'all') {
    if (!!chainCode) {
      path += `/chain/${chainCode}`
    }
    path += `/list`
    
    // conditionsオブジェクトから直接クエリパラメータを設定
    if (Object.keys(conditions).length > 0) {
      const searchParams = new URLSearchParams()
      Object.entries(conditions).forEach(([key, value]) => {
        searchParams.set(key, value)
      })
      return path + `?${searchParams.toString()}`
    }
    
    return path
  }

  if (prefecture && prefecture !== 'current_location')
    path += `/pref/${prefecture}`

  if (areaSlug && !stationCode) path += `/area/${areaSlug}`
  if (stationCode && !areaSlug) path += `/station/${stationCode}`

  if (chainCode && !keyword) path += `/chain/${chainCode}`

  // URLSearchParamsを使用してクエリパラメータを構築
  const searchParams = new URLSearchParams()
  
  if (keyword && !chainCode) {
    searchParams.set('keyword', keyword)
    if (selectedDay !== '0') searchParams.set('selected_day', selectedDay)
  } else if (selectedDay !== '0') {
    searchParams.set('selected_day', selectedDay)
  }

  // conditionsオブジェクトから直接クエリパラメータを設定
  Object.entries(conditions).forEach(([key, value]) => {
    searchParams.set(key, value)
  })

  // クエリパラメータがある場合は追加
  const queryString = searchParams.toString()
  if (queryString) {
    path += `?${queryString}`
  }

  return path
}
